import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../components/BackButton";

const card = { background: "white", borderRadius: "16px", padding: "20px", marginBottom: "12px", boxShadow: "0 4px 24px rgba(0,0,0,0.07)", border: "1px solid #f1f5f9" };
const cardTitle = { fontSize: "15px", fontWeight: 700, color: "#1e293b", margin: "0 0 10px" };

const AboutPage = () => {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div style={{
      minHeight: "100svh",
      background: "#f3f4f6",
      fontFamily: "system-ui, -apple-system, sans-serif",
      padding: "16px 16px 40px",
      boxSizing: "border-box"
    }}>
      <div style={{ maxWidth: "680px", margin: "0 auto" }}>
        <BackButton fallback="/" />

        {/* Header */}
        <div style={{ textAlign: "center", padding: "24px 0 20px" }}>
          <div style={{ fontSize: "48px", marginBottom: "12px" }}>💘</div>
          <h1 style={{ fontSize: "28px", fontWeight: 900, color: "#1e293b", margin: "0 0 8px" }}>
            CrushNow
          </h1>
          <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>Version 1.1.2 · 2026</p>
        </div>

        {/* C'est quoi */}
        <div style={card}>
          <h2 style={cardTitle}>C'est quoi CrushNow ?</h2>
          <p style={{ fontSize: "14px", color: "#475569", lineHeight: 1.7, margin: 0 }}>
            CrushNow permet de scanner un produit en magasin et de le sauvegarder dans ta liste personnelle.
            Quand le vendeur met à jour une info (prix, stock, promo), tu es averti automatiquement.
          </p>
        </div>

        {/* Comment ça marche */}
        <div style={card}>
          <h2 style={{ ...cardTitle, marginBottom: "14px" }}>Comment ça marche ?</h2>
          {[
            { emoji: "📱", title: "Scanne", desc: "Pointe ton téléphone sur le code-barres d'un produit en magasin." },
            { emoji: "💾", title: "Sauvegarde", desc: "Le produit rejoint ta Crush List automatiquement." },
            { emoji: "🔔", title: "Sois alerté", desc: "Reçois une notification dès que le vendeur met à jour une info." },
            { emoji: "🗺️", title: "Explore", desc: "Retrouve sur la carte tous les endroits où tu as scanné." },
          ].map((step, i) => (
            <div key={i} style={{ display: "flex", gap: "12px", marginBottom: i < 3 ? "14px" : 0 }}>
              <div style={{ fontSize: "24px", flexShrink: 0 }}>{step.emoji}</div>
              <div>
                <div style={{ fontSize: "13px", fontWeight: 700, color: "#1e293b" }}>{step.title}</div>
                <div style={{ fontSize: "13px", color: "#64748b", lineHeight: 1.5 }}>{step.desc}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Pour les vendeurs */}
        <div style={card}>
          <h2 style={cardTitle}>Tu es commerçant ?</h2>
          <p style={{ fontSize: "14px", color: "#475569", lineHeight: 1.7, margin: "0 0 14px" }}>
            CrushNow te connecte directement avec les clients qui ont déjà montré de l'intérêt pour tes produits.
            Mets à jour tes infos, ils sont notifiés instantanément.
          </p>
          <button
            onClick={() => navigate("/login")}
            style={{
              width: "100%", height: "44px", background: "linear-gradient(135deg, #e11d48, #f43f5e)",
              color: "white", border: "none", borderRadius: "10px",
              fontSize: "14px", fontWeight: 700, cursor: "pointer"
            }}
          >
            Créer mon espace vendeur →
          </button>
        </div>

        {/* Liens légaux */}
        <div style={card}>
          <h2 style={cardTitle}>Informations légales</h2>
          {[
            { label: "CGU", path: "/cgu" },
            { label: "Politique de confidentialité", path: "/privacy" },
            { label: "Mentions légales", path: "/legal" },
            { label: "Mes données", path: "/my-data" },
          ].map((link, i) => (
            <div
              key={i}
              onClick={() => navigate(link.path)}
              style={{
                display: "flex", justifyContent: "space-between", alignItems: "center",
                padding: "12px 0", borderBottom: i < 3 ? "1px solid #f1f5f9" : "none",
                cursor: "pointer"
              }}
            >
              <span style={{ fontSize: "14px", color: "#475569" }}>{link.label}</span>
              <span style={{ color: "#cbd5e1" }}>›</span>
            </div>
          ))}
        </div>

        {/* Feedback */}
        <div
          onClick={() => navigate("/feedback")}
          style={{
            background: "linear-gradient(135deg, #e11d48, #f43f5e)",
            borderRadius: "16px", padding: "20px", marginBottom: "24px",
            cursor: "pointer", textAlign: "center",
            boxShadow: "0 4px 20px rgba(225,29,72,0.3)"
          }}
        >
          <div style={{ fontSize: "24px", marginBottom: "6px" }}>💬</div>
          <div style={{ fontSize: "15px", fontWeight: 700, color: "white" }}>Donner mon avis</div>
          <div style={{ fontSize: "12px", color: "rgba(255,255,255,0.8)", marginTop: "4px" }}>
            Tu utilises l'app en beta ? Tes retours comptent vraiment.
          </div>
        </div>

        {/* Footer */}
        <div style={{ textAlign: "center", padding: "0 0 32px" }}>
          <p style={{ fontSize: "11px", color: "#cbd5e1", margin: "0 0 4px" }}>
            💘 CrushNow® — Marque enregistrée INPI n° 5152773
          </p>
          <p style={{ fontSize: "11px", color: "#cbd5e1", margin: 0 }}>
            © 2026 Tous droits réservés
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
